import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import PublicLayout from '../layouts/PublicLayout';

const Privacy = () => {
  return (
    <PublicLayout>
      <Container className="py-5">
        <Row className="justify-content-center">
          <Col md={10}>
            <Card className="shadow">
              <Card.Header className="bg-dark text-white">
                <h1 className="h3 mb-0">Privacy Policy for Veritas Ratings</h1>
              </Card.Header>
              <Card.Body className="bg-light">
                <p className="mb-4">
                  <strong>Last Updated:</strong> 5/27/2025
                </p>
                <p className="mb-4">
                  Veritas Ratings ("we," "our," or "us") is committed to
                  protecting your privacy. This Privacy Policy outlines how we
                  collect, use, store, and share your information when you use
                  our services.
                </p>

                <h2 className="h4 mb-4">1. Information We Collect</h2>
                <p>
                  We collect the following personal information from users when
                  they engage with our services:
                </p>
                <ul>
                  <li>Full Name</li>
                  <li>Email Address</li>
                  <li>Phone Number</li>
                  <li>Payment Information</li>
                  <li>DD214 and all information contained therein</li>
                  <li>Social Security Number (SSN)</li>
                  <li>Date of Birth (DOB)</li>
                  <li>Military Status</li>
                  <li>VA Disability Rating Percentage</li>
                  <li>Marital Status</li>
                  <li>Medical Records</li>
                  <li>Personal/spouse/buddy statements</li>
                </ul>

                <h2 className="h4 mb-4">2. How Users Access Our Services</h2>
                <p>
                  Users create accounts via email and password. We implement
                  two-factor authentication (2FA) for enhanced account security.
                </p>

                <h2 className="h4 mb-4">3. Use of Device Features</h2>
                <p>
                  Our platform does not request access to any device features
                  such as camera, microphone, location, or media files, unless
                  the video conferencing/transcription tool is in use.
                </p>

                <h2 className="h4 mb-4">4. How We Use Your Information</h2>
                <p>We use your data exclusively to:</p>
                <ul>
                  <li>
                    Deliver our core services related to VA disability claims
                    processing
                  </li>
                  <li>
                    Facilitate secure communication with medical providers
                  </li>
                  <li>Support your journey through the VBA system</li>
                </ul>

                <h2 className="h4 mb-4">5. Data Sharing</h2>
                <p>
                  We share specific user information only with the following
                  third parties, under strict confidentiality and necessity:
                </p>
                <ul>
                  <li>
                    <strong>Stripe:</strong> For secure payment processing
                  </li>
                  <li>
                    <strong>Medical Providers:</strong> To facilitate disability
                    evaluations and complete medical examinations essential to
                    the claims process
                  </li>
                </ul>
                <p>
                  We do not sell or lease your personal information to any third
                  party.
                </p>

                <h2 className="h4 mb-4">
                  6. Cookies and Tracking Technologies
                </h2>
                <p>
                  We use cookies and similar tracking technologies to improve
                  your experience on our site. These may include session
                  cookies, analytics tools, and preference trackers.
                </p>

                <h2 className="h4 mb-4">7. User Rights and Data Access</h2>
                <p>You have the right to:</p>
                <ul>
                  <li>
                    Request deletion of your account and all associated data
                  </li>
                  <li>
                    Contact support to manage or review your personal
                    information
                  </li>
                </ul>
                <p>
                  Requests can be submitted through our customer support
                  channel.
                </p>

                <h2 className="h4 mb-4">8. Data Retention and Protection</h2>
                <p>We retain data:</p>
                <ul>
                  <li>
                    As long as needed to ensure the success of your VBA claims
                  </li>
                  <li>
                    Indefinitely (in perpetuity) for returning customers, unless
                    deletion is requested
                  </li>
                </ul>
                <p>
                  All data is stored securely and protected via encryption,
                  access controls, and regular compliance audits.
                </p>

                <h2 className="h4 mb-4">9. Regulatory Compliance</h2>
                <p>
                  Veritas Ratings complies with the Health Insurance Portability
                  and Accountability Act (HIPAA) to ensure the confidentiality
                  and integrity of your healthcare-related information.
                </p>

                <h2 className="h4 mb-4">10. Contact Us</h2>
                <p>
                  For any questions, requests, or concerns about this Privacy
                  Policy, please contact:
                </p>
                <ul>
                  <li>
                    <strong>Email:</strong> info@veritasratings.com
                  </li>
                  <li>
                    <strong>Phone:</strong> 615-961-0317
                  </li>
                  <li>
                    <strong>Mailing Address:</strong>
                    <br />
                    6640 Carothers Parkway, Suite 410
                    <br />
                    Franklin, TN 37067
                  </li>
                </ul>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </PublicLayout>
  );
};

export default Privacy;
